import { o_util } from "../../common/namespaces";
import { assignNamespace } from "../../common/namespace-utils";

import {
  addDelegationConfig,
  addEvent,
  findDelegation,
  findDelegationConfig,
  getContainerElement,
  queryDelegationTargets,
} from "./utils.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function delegate<
  T extends HTMLElement | Document,
  K extends keyof HTMLElementEventMap,
  S extends keyof HTMLElementTagNameMap,
  F extends (this: E, ev: HTMLElementEventMap[K]) => void,
  E extends Element,
>(
  containerOrSelector: T | S | string,
  eventType: K,
  targetSelector: string,
  listener: F,
  options: boolean | AddEventListenerOptions = false,
): boolean {
  const container = getContainerElement(containerOrSelector);

  if (!container) {
    /*                   */
    return false;
  }

  let config = findDelegationConfig(container);
  if (!config) {
    config = addDelegationConfig(container);
  }

  /*                              */
  queryDelegationTargets(container, targetSelector).forEach((element) =>
    addEvent({ target: element, eventType, listener, options }),
  );

  /*                                                         */
  const delegation = findDelegation(config, eventType, targetSelector, listener);
  if (!delegation) {
    /*                                   */
    config.delegations.push({ listener, options, eventType, targetSelector });
  }

  return true;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function undelegate<
  T extends HTMLElement | Document,
  K extends keyof HTMLElementEventMap,
  S extends keyof HTMLElementTagNameMap,
  F extends (this: Element, ev: HTMLElementEventMap[K]) => void,
>(
  containerOrSelector: T | S | string,
  eventType: K,
  targetSelector: string,
  listener: F,
  options?: boolean | EventListenerOptions,
): boolean {
  const element = getContainerElement(containerOrSelector);

  if (!element) {
    /*                   */
    return false;
  }

  const config = findDelegationConfig(element);
  if (!config) {
    /*                                          */
    return false;
  }

  /*                                                       */
  const delegation = findDelegation(config, eventType, targetSelector, listener);
  if (!delegation) {
    /*                                      */
    return false;
  }

  /*                                */
  config.delegations.splice(config.delegations.indexOf(delegation), 1);

  /*                              */
  queryDelegationTargets(element, targetSelector).map((target) =>
    target.removeEventListener(eventType, listener, options),
  );

  return true;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function stop<T extends Event>(event: T): void {
  event.stopPropagation();
  event.preventDefault();
}

/**
 *
 *
 *
 *
 *
 */
export function whichTransitionEndEvent(): string {
  const el = document.createElement("fakeelement");

  const res = Object.entries({
    WebkitTransition: "webkitTransitionEnd",
    transition: "transitionend",
    OTransition: "oTransitionEnd",
    MozTransition: "transitionend",
    DEFAULT: "",
  })
    .filter(([k]) => el.style[k as keyof CSSStyleDeclaration] !== undefined || k === "DEFAULT")
    .map(([, v]) => v)[0];

  return res;
}

/**
 *
 */
export type Unset = () => void;

type ElementToEvents<E extends EventTarget> = E extends HTMLElement
  ? HTMLElementEventMap
  : E extends Window
    ? WindowEventMap
    : E extends Element
      ? ElementEventMap
      : E extends AbortSignal
        ? AbortSignalEventMap
        : E extends MediaQueryList
          ? MediaQueryListEventMap
          : { [type: string]: Event };

/*                                              */
type TypeToEvent<K, M> = K extends keyof M ? M[K] : Event;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function on<E extends EventTarget, K extends keyof ElementToEvents<E> | (string & {})>(
  element: E,
  type: K,
  listener: (this: E, ev: TypeToEvent<K, ElementToEvents<E>>) => unknown,
  options?: boolean | AddEventListenerOptions,
): Unset {
  function wrapper(this: E, ev: TypeToEvent<K, ElementToEvents<E>>): unknown {
    return listener.call(this, ev);
  }
  element.addEventListener(type as never, wrapper as never, options);
  return () => element.removeEventListener(type as never, wrapper as never, options);
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const withEvents = <EventMap>(
  element: HTMLElement,
): (<K extends keyof EventMap>(
  type: K,
  listener: (this: HTMLElement, ev: TypeToEvent<K, EventMap>) => unknown,
  options?: boolean | AddEventListenerOptions,
) => Unset) => (on<HTMLElement, string>).bind(undefined, element) as never;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const unsetAll =
  (...unsets: (Unset | undefined | void | null)[]): Unset =>
  () => {
    for (const u of unsets) u?.();
  };

assignNamespace(o_util, "event", {
  delegate,
  undelegate,
  stop,
  whichTransitionEndEvent,
  on,
  withEvents,
  unsetAll,
});
